import { useState } from 'react';
import { Button } from '@upmc/ims.component-library';
import Menu from '@mui/material/Menu';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditSafetyToggle from './ApplicationSettings/EditSafetyToggle';
import MaterialIcon from '@material/react-material-icon';
import styles from './ApplicationSettings.module.scss';

const ApplicationSettings = ({ currentUser, selectedApp, setSelectedApp }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return selectedApp ? (
		<div>
			<Button
				sx={{marginLeft: '10px'}}
				id='basic-button'
				aria-controls={open ? 'basic-menu' : undefined}
				aria-haspopup='true'
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
			>
				<MaterialIcon icon='settings' />
			</Button>
			<Menu
				id='basic-menu'
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
			>
				<div className={styles.menu}>
					<FormGroup>
						<FormControlLabel
							control={
								<EditSafetyToggle
									selectedApp={selectedApp}
									currentUser={currentUser}
									setSelectedApp={setSelectedApp}
								/>
							}
							label={<>Is Safe To edit</>}
						/>
					</FormGroup>
				</div>
			</Menu>
		</div>
	) : null;
};

export default ApplicationSettings;
